/* src/app/modules/home/home.component.scss */
.home-main-container {
  height: 100vh;
  overflow: hidden;
  transform: scale(0);
  opacity: 0;
}
.home-main-container-loading {
  transform: scale(0);
}
.home-main-container-loaded {
  animation: zoom-opacity ease-in-out 0.7s 0.1s forwards;
}
@keyframes zoom-opacity {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
/*# sourceMappingURL=home.component.css.map */
